import VueI18n from 'vue-i18n'
import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

import common_enUS from '@translations/common/en-US.json'
import pdp_enUS from '@translations/pdp/en-US.json'
import virtualMirror_enUS from '@translations/virtual-mirror/en-US.json'
import storeLocator_enUS from '@translations/store-locator/en-US.json'
import payOverTime_enUS from '@translations/pay-over-time/en-US.json'
import paypalOverlay_enUS from '@translations/paypal-overlay/en-US.json'
import paymentMessageBox_enUS from '@translations/payment-message-box/en-US.json'
import axios from 'axios'
type defaultLocaleMapTupleT = [string, string[]]
class i18n {
  readonly locale: string
  private instance: VueI18n
  public translations: any
  private defaultLocaleMap: Array<defaultLocaleMapTupleT> = [
    [WcsLocales.DE_DE, [WcsLocales.DE_AT, WcsLocales.DE_LU, WcsLocales.DE_CH]],
    [WcsLocales.ES_ES, [WcsLocales.ES_MX, WcsLocales.ES_LA, WcsLocales.ES_AR]],
    [WcsLocales.FR_FR, [WcsLocales.FR_BE, WcsLocales.FR_CA, WcsLocales.FR_CH]],
    [WcsLocales.IT_IT, [WcsLocales.IT_CH]],
    [WcsLocales.NL_NL, [WcsLocales.NL_BE]],
  ]

  constructor() {
    const { locale } = wcs.getStoreConfig()
    this.instance = {} as VueI18n
    this.locale = locale
    this.translations = {}
  }

  getInstance(): VueI18n {
    return this.instance
  }

  setupLocalization() {
    const i18n = new VueI18n({
      locale: this.locale,
      fallbackLocale: WcsLocales.EN_US,
      messages: {
        [WcsLocales.EN_US]: {
          ...common_enUS,
          ...pdp_enUS,
          ...virtualMirror_enUS,
          ...storeLocator_enUS,
          ...payOverTime_enUS,
          ...paypalOverlay_enUS,
          ...paymentMessageBox_enUS,
        },
      },
    })

    this.loadTranslations(i18n.locale).then((currentTranslations) => {
      this.instance = i18n
      this.instance.mergeLocaleMessage(i18n.locale, currentTranslations)
      this.instance.fallbackLocale = this.findHasDefault(this.instance.locale)
    })
    return i18n
  }

  async loadTranslations(locale: string): Promise<{ [k: string]: string }> {
    try {
      const request = await axios.get(`/rbstatichtml/assets/translations/${locale}.json`)
      return request?.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }

  async loadTranslationsBySection(_locale?: string): Promise<void> {
    // TODO: Remove
    return
  }

  private findHasDefault(currentLocale: string) {
    if (currentLocale.includes('en-')) {
      return WcsLocales.EN_US
    }
    const findLocale = this.defaultLocaleMap.find(([, ml]) => {
      return ml.includes(currentLocale)
    })
    return findLocale ? findLocale[0] : WcsLocales.EN_US
  }
}

export default new i18n()
